import { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import AddCategory from "./components/addCategory";
import { Button } from "../../../components/ui/button";
import Common from "../../../helper/common";
import AdvanceTable from "../../../components/advanceTable";
import { respEnum, SearchTypeEnum } from "../../../constants/appConstant";
import { AppSelect } from "../../../components/appComponents";

const ProductCategories = () => {
  const [data, setData] = useState({});
  const [isactive, setIsactive] = useState(true);
  const [open, setOpen] = useState(false);
  const [refId, setRefId] = useState(null);

  // Status filter options
  const statusOptions = [
    { id: null, name: "All Status" },
    { id: true, name: "Active" },
    { id: false, name: "Inactive" },
  ];

  useEffect(() => {
    getData(1);
  }, []);

  useEffect(() => {
    getData(1);
  }, [isactive]);

  useEffect(() => {
    if (!open && refId) {
      setRefId(null);
    }
  }, [open]);

  const resetFilters = () => {
    setIsactive(null);
  };

  const getData = async (
    pageNumber,
    searchTerm = "",
    recordsToDisplay = null
  ) => {
    const response = await Common.ApiService.getInstance().request(
      "GetProductCategoriesList",
      {
        pageNumber: pageNumber,
        q: searchTerm,
        isactive: isactive,
        parentid: null,
        includeChildren: false,
        recordsToDisplay,
      },
      "POST"
    );

    if (response?.status === respEnum.Success && response?.data?.[0]) {
      setData(response.data[0]);
    }
  };

  const _handleDelete = async (id) => {
    const isConfirmed = await Common.SweetAlert.confirmation(
      "Are you sure you want to delete this Category?",
      "Delete Category"
    );
    if (isConfirmed) {
      let resp = await Common.ApiService.getInstance().request(
        `DeleteProductCategory?id=${id}`,
        {},
        "Delete"
      );

      if (resp.status === respEnum.Success) {
        Common.SweetAlert.alert(resp.message, "success");
        setTimeout(() => {
          getData(1);
        }, 500);
      } else {
        Common.SweetAlert.alert(
          resp.message || "Failed to delete category",
          "error"
        );
      }
    }
  };

  const _addUpdateTrigger = () => (
    <Button size="icon" variant="outline" color="secondary" className="h-7 w-7">
      <Icon icon="heroicons:pencil" className="h-4 w-4" />
    </Button>
  );

  const _onEdit = async (id) => {
    setOpen(true);
    setRefId(id);
  };

  const actions = [
    {
      type: "edit",
      onClick: (val) => _onEdit(val.id),
    },
    {
      type: "delete",
      onClick: (val) => _handleDelete(val.id),
    },
  ];

  const _thead = [
    { title: "Id", type: "number", isVisible: false, key: "id" },
    {
      title: "Name",
      type: "text",
      isVisible: true,
      key: "name",
    },
    {
      title: "Sort Order",
      type: "text",
      isVisible: true,
      key: "sortOrder",
      render: (row) => (
        <span className="px-2 py-1 rounded-full text-xs bg-blue-100 text-blue-800">
          {row.sortOrder || "N/A"}
        </span>
      ),
    },
    {
      title: "Status",
      type: "text",
      isVisible: true,
      key: "isactive",
      render: (row) => (
        <span
          className={`px-2 py-1 rounded-full text-xs ${
            row.isactive
              ? "bg-green-100 text-green-800"
              : "bg-red-100 text-red-800"
          }`}
        >
          {row.isactive ? "Active" : "Inactive"}
        </span>
      ),
    },
    {
      title: "Created Date",
      type: "text",
      isVisible: true,
      key: "createdon",
      render: (row) => (
        <span className="text-gray-600">
          {row.createdon
            ? Common.moment(row.createdon).format("DD MMM YYYY")
            : "N/A"}
        </span>
      ),
    },
  ];

  return (
    <>
      {/* Filters */}
      <div className="grid grid-cols-1 md:grid-cols-6 gap-4 mb-4 p-4 bg-white rounded-lg shadow-sm border">
        <AppSelect
          value={isactive}
          onChange={setIsactive}
          label="Status"
          data={statusOptions}
          className="col-span-1"
        />

        <Button
          className="mt-6 h-8 col-span-1"
          onClick={resetFilters}
          variant="outline"
        >
          Reset Filters
        </Button>
      </div>

      {data?.data && (
        <AdvanceTable
          title={"Product Categories"}
          columns={_thead.filter((item) => item.isVisible)}
          data={data}
          getData={getData}
          search={SearchTypeEnum.Server_Search}
          searchInputClassName="custom-search-mobile "
          addButton={() => (
            <AddCategory
              id={refId}
              onClose={() => getData(1)}
              open={open}
              setOpen={setOpen}
            />
          )}
          showPagination={true}
          showAddButton
          actionButtons={actions}
          updateTrigger={_addUpdateTrigger}
        />
      )}
    </>
  );
};

export default ProductCategories;
